import { CredentialLayout } from "../CredentialLayout";
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { CredentialProps } from "../CredentialProps";
import { Component } from "react";

interface HostBasicAuthViewPageProps extends NSARouterMakerResult, CredentialProps { }

class HostBasicAuthViewPage extends Component<HostBasicAuthViewPageProps>
{
    override render()
    {
        return (
            <CredentialLayout
                {...this.props}
                action={{
                    description: "This section shows the full details of a Host Basic Auth credential, including its name, host, and the username and password it stores as secrets. You can review its history and tags and copy any field, while the secret values stay protected."
                }}
                pages={{
                    entity: CredentialEntities.host_basic_auth(this.props),
                    view: {}
                }}
            >
                <></>
            </CredentialLayout>
        );
    }
}

export default HostBasicAuthViewPage;